import styled from "styled-components";

const SeparForm = styled.hr`
margin-top:3%;
margin-bottom:3%;
`;

export default SeparForm;